<template>
  <div>
    <div class="panel panel-default" id="free-offer-top-panel">
      <div class="panel-body">
        <div class="col-md-12">
          <!-- Add buttons here  -->
          <button
            class="btn btn-raised btn-top-bar"
            :disabled="!refreshEnabled"
            @click="getFreeOffers()"
          >
            <i class="material-icons md-36">refresh</i>
            <template v-if="!isSmallScreen">
              <br />
              {{ lang.SFO000 }}
            </template>
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            :disabled="!selectedFreeOfferGuid"
            @click="openFreeOfferDetailsDialog()"
          >
            <i class="material-icons md-36">info_outline</i>
            <template v-if="!isSmallScreen">
              <br />
              {{ lang.SFO001 }}
            </template>
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            @click="openFreeOfferFilterChecksDialog()"
          >
            <i class="material-icons md-36">filter_list</i>
            <template v-if="!isSmallScreen">
              <br />
              {{ lang.SFO016 }}
            </template>
          </button>
        </div>
      </div>
      <div class="panel-body">
        <div class="col-xs-6 col-md-4">
          <div class="form-group searchbar">
            <input
              type="search"
              class="form-control"
              id="inputSearch"
              :placeholder="lang.SFO002"
              v-model="filterStrings.Search"
              @keyup.enter="(selectedPage = 1), getFreeOffers()"
            />
          </div>
        </div>
        <div class="col-xs-6 col-md-2">
          <a
            role="button"
            class="btn"
            id="orderByDistanceButton"
            v-if="filterOptions.CurrentLocation"
            @click="orderTableByColumn('Distance')"
          >
            {{ lang.SFO025 }}
            <span
              v-if="showSortArrow('Distance', true)"
              class="glyphicon glyphicon-triangle-top"
            ></span>
            <span
              v-else-if="showSortArrow('Distance', false)"
              class="glyphicon glyphicon-triangle-bottom"
            ></span>
            <span v-else class="glyphicon glyphicon-sort"></span>
          </a>
        </div>
        <div class="col-lg-6 col-xs-12 nopadding">
          <ul class="pagination-fonts pagination btn-group">
            <li>
              <a
                role="button"
                class="dropdown-toggle"
                data-toggle="dropdown"
                id="elementsPerPageDropdown"
              >
                <i class="material-icons md-18">view_headline</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="elementsPerPageDropdown"
                :delay="globals.tooltipDelay"
                >{{ lang.SFO004 }}</b-tooltip
              >
              <ul class="dropdown-menu">
                <!-- Add dropdown entries here -->
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 20 }"
                    role="button"
                    @click="updatePaging(1, 20)"
                    >20</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 50 }"
                    role="button"
                    @click="updatePaging(1, 50)"
                    >50</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 100 }"
                    role="button"
                    @click="updatePaging(1, 100)"
                    >100</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 200 }"
                    role="button"
                    @click="updatePaging(1, 200)"
                    >200</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 500 }"
                    role="button"
                    @click="updatePaging(1, 500)"
                    >500</a
                  >
                </li>
              </ul>
            </li>

            <!-- Jump to first page -->
            <li
              v-bind:class="{ disabled: selectedPage == 1 }"
              @click="updatePaging(1, 0)"
            >
              <a role="button" id="firstPageButton">
                <i class="material-icons md-18">first_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="firstPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.SFO005 }}</b-tooltip
              >
            </li>
            <!-- ... -->
            <li v-if="pageCount > 7 && selectedPage > 4" class="disabled">
              <a role="button">...</a>
            </li>
            <!-- Pagenumbers -->
            <li
              v-for="pageNumber in getVisiblePages()"
              :key="pageNumber"
              v-bind:class="{ active: selectedPage == pageNumber }"
              @click="updatePaging(pageNumber, 0)"
            >
              <a role="button">{{ pageNumber }}</a>
            </li>
            <!-- ... -->
            <li
              v-if="pageCount > 7 && selectedPage < pageCount - 3"
              class="disabled"
            >
              <a role="button">...</a>
            </li>
            <!-- Jump to last page -->
            <li
              v-bind:class="{ disabled: selectedPage == pageCount }"
              @click="updatePaging(pageCount, 0)"
            >
              <a role="button" id="lastPageButton">
                <i class="material-icons md-18">last_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="lastPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.SFO006 }}</b-tooltip
              >
            </li>
            <li class="disabled">
              <a role="button" id="freeOfferTotalElementsCounter">{{
                checkCount
              }}</a>
              <b-tooltip
                ref="tooltip"
                target="freeOfferTotalElementsCounter"
                :delay="globals.tooltipDelay"
                >{{ lang.SFO024 }}</b-tooltip
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="panel panel-default" id="freeofferstable">
      <div class="panel-body">
        <div class="table-space main-table-scrollbar">
          <table class="table table-striped table-hover main-table">
            <thead>
              <tr>
                <th
                  style="width: 8%"
                  class="text-center sticky-header"
                  v-if="!isSmallScreen"
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="orderTableByColumn('SurveyInstanceId')"
                  >
                    {{ lang.SFO008 }}
                    <span
                      v-if="showSortArrow('SurveyInstanceId', true)"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="showSortArrow('SurveyInstanceId', false)"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th
                  :style="`width:${isSmallScreen ? '25' : '13'}%;`"
                  class="text-center sticky-header"
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="orderTableByColumn('SurveyTitle')"
                  >
                    {{ isSmallScreen ? lang.SFO017 : lang.SFO012 }}
                    <span
                      v-if="showSortArrow('SurveyTitle', true)"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="showSortArrow('SurveyTitle', false)"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th
                  style="width: 30%"
                  class="text-center sticky-header"
                  v-if="!isSmallScreen"
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="orderTableByColumn('SurveyInstanceDescription')"
                  >
                    {{ lang.SFO011 }}
                    <span
                      v-if="showSortArrow('SurveyInstanceDescription', true)"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="showSortArrow('SurveyInstanceDescription', false)"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>

                <th
                  style="width: 15%"
                  class="text-center sticky-header"
                  v-if="isSmallScreen"
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="orderTableByColumn('LocationPostalCode')"
                  >
                    {{ lang.SFO018 }}
                    <span
                      v-if="showSortArrow('LocationPostalCode', true)"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="showSortArrow('LocationPostalCode', false)"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>

                <th
                  style="width: 6%"
                  class="text-center sticky-header"
                  v-if="!isSmallScreen"
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="orderTableByColumn('LocationCity')"
                  >
                    {{ lang.SFO018 }}
                    <span
                      v-if="showSortArrow('LocationCity', true)"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="showSortArrow('LocationCity', false)"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th
                  style="width: 6%"
                  class="text-center sticky-header"
                  v-if="!isSmallScreen"
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="orderTableByColumn('LocationPostalCode')"
                  >
                    {{ lang.SFO022 }}
                    <span
                      v-if="showSortArrow('LocationPostalCode', true)"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="showSortArrow('LocationPostalCode', false)"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th
                  style="width: 5%"
                  class="text-center sticky-header"
                  v-if="!isSmallScreen"
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="orderTableByColumn('LocationCountry')"
                  >
                    {{ lang.SFO023 }}
                    <span
                      v-if="showSortArrow('LocationCountry', true)"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="showSortArrow('LocationCountry', false)"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th
                  style="width: 8%"
                  class="text-center sticky-header"
                  v-if="!isSmallScreen"
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="orderTableByColumn('ScenarioName')"
                  >
                    {{ lang.SFO020 }}
                    <span
                      v-if="showSortArrow('ScenarioName', true)"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="showSortArrow('ScenarioName', false)"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th style="width: 8%" class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="orderTableByColumn('SurveyInstanceInfo')"
                  >
                    {{ lang.SFO021 }}
                    <span
                      v-if="showSortArrow('SurveyInstanceInfo', true)"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="showSortArrow('SurveyInstanceInfo', false)"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th
                  style="width: 10%"
                  class="text-center sticky-header"
                  v-if="!isSmallScreen"
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="orderTableByColumn('LocationAdditionalInfo')"
                  >
                    {{ lang.SFO019 }}
                    <span
                      v-if="showSortArrow('LocationAdditionalInfo', true)"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="showSortArrow('LocationAdditionalInfo', false)"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th
                  :style="`width:${isSmallScreen ? '15' : '7'}%;`"
                  class="text-center sticky-header"
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="orderTableByColumn('SurveyInstanceSince')"
                  >
                    {{ lang.SFO009 }}
                    <span
                      v-if="showSortArrow('SurveyInstanceSince', true)"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="showSortArrow('SurveyInstanceSince', false)"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th
                  :style="`width:${isSmallScreen ? '15' : '7'}%;`"
                  class="text-center sticky-header"
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="orderTableByColumn('SurveyInstanceUntil')"
                  >
                    {{ lang.SFO010 }}
                    <span
                      v-if="showSortArrow('SurveyInstanceUntil', true)"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="showSortArrow('SurveyInstanceUntil', false)"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th
                  :style="`width:${isSmallScreen ? '15' : '8'}%;`"
                  class="text-center sticky-header"
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="orderTableByColumn('TotalPayment')"
                  >
                    <template v-if="!isSmallScreen">{{ lang.SFO013 }}</template>
                    <i v-else class="material-icons md-20">euro_symbol</i>
                    <span
                      v-if="showSortArrow('TotalPayment', true)"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="showSortArrow('TotalPayment', false)"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
              </tr>
              <tr v-if="globals.isLargeScreen()" class="table-filters">
                <th class="nopadding sticky-filter" style="width: 8%">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      v-model="filterStrings.SurveyInstanceId"
                      :placeholder="lang.SFO003"
                      @keyup.enter="(selectedPage = 1), getFreeOffers()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter" style="width: 13%">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      v-model="filterStrings.SurveyTitle"
                      :placeholder="lang.SFO003"
                      @keyup.enter="(selectedPage = 1), getFreeOffers()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter" style="width: 14%">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      v-model="filterStrings.SurveyInstanceDescription"
                      :placeholder="lang.SFO003"
                      @keyup.enter="(selectedPage = 1), getFreeOffers()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter" style="width: 6%">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      v-model="filterStrings.LocationCity"
                      :placeholder="lang.SFO003"
                      @keyup.enter="(selectedPage = 1), getFreeOffers()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter" style="width: 6%">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      v-model="filterStrings.LocationPostalCode"
                      :placeholder="lang.SFO003"
                      @keyup.enter="(selectedPage = 1), getFreeOffers()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter" style="width: 5%">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      v-model="filterStrings.LocationCountry"
                      :placeholder="lang.SFO003"
                      @keyup.enter="(selectedPage = 1), getFreeOffers()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter" style="width: 8%">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      v-model="filterStrings.ScenarioName"
                      :placeholder="lang.SFO003"
                      @keyup.enter="(selectedPage = 1), getFreeOffers()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter" style="width: 8%">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      v-model="filterStrings.SurveyInstanceInfo"
                      :placeholder="lang.SFO003"
                      @keyup.enter="(selectedPage = 1), getFreeOffers()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter" style="width: 10%">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      v-model="filterStrings.LocationAdditionalInfo"
                      :placeholder="lang.SFO003"
                      @keyup.enter="(selectedPage = 1), getFreeOffers()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter" style="width: 7%">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      v-model="filterStrings.SurveyInstanceSince"
                      :placeholder="lang.SFO003"
                      @keyup.enter="(selectedPage = 1), getFreeOffers()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter" style="width: 7%">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      v-model="filterStrings.SurveyInstanceUntil"
                      :placeholder="lang.SFO003"
                      @keyup.enter="(selectedPage = 1), getFreeOffers()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter" style="width: 8%">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      v-model="filterStrings.TotalPayment"
                      :placeholder="lang.SFO003"
                      @keyup.enter="(selectedPage = 1), getFreeOffers()"
                    />
                  </div>
                </th>
              </tr>
            </thead>
            <tbody class="main-table-scrollbar">
              <tr
                role="button"
                :key="freeOffer.SurveyInstanceGuid"
                class="text-center"
                @click="selectedFreeOfferGuid = freeOffer.SurveyInstanceGuid"
                @dblclick="openFreeOfferDetailsDialog()"
                :class="{
                  info: freeOffer.SurveyInstanceGuid === selectedFreeOfferGuid,
                }"
                v-for="freeOffer in freeOffers"
              >
                <td style="width: 8%" v-if="!isSmallScreen">
                  {{ freeOffer.SurveyInstanceId }}
                </td>
                <td :style="`width:${isSmallScreen ? '25' : '13'}%;`">
                  {{ freeOffer.SurveyTitle }}
                  <i
                    class="material-icons"
                    :class="{ 'md-18': !isSmallScreen, 'md-24': isSmallScreen }"
                    v-if="freeOffer.LocationFree"
                    >location_off</i
                  >
                </td>
                <td
                  id="freeOfferDescription"
                  style="width: 16%"
                  v-if="!isSmallScreen"
                >
                  {{
                    globals.truncateString(
                      globals.getMarkupText(
                        freeOffer.SurveyInstanceDescription
                      ),
                      50
                    )
                  }}
                </td>
                <td style="width: 7%" v-if="!isSmallScreen">
                  {{ freeOffer.LocationCity }}
                </td>
                <td style="width: 7%" v-if="!isSmallScreen">
                  {{ freeOffer.LocationPostalCode }}
                </td>
                <td style="width: 15%" v-if="isSmallScreen">
                  {{ freeOffer.LocationPostalCode }}
                  {{ freeOffer.LocationCity }}
                </td>
                <td style="width: 5%" v-if="!isSmallScreen">
                  {{ freeOffer.LocationCountry }}
                </td>
                <td style="width: 8%" v-if="!isSmallScreen">
                  {{ freeOffer.ScenarioName }}
                </td>
                <td style="width: 8%">
                  {{ freeOffer.SurveyInstanceInfo }}
                </td>
                <td style="width: 10%" v-if="!isSmallScreen">
                  {{
                    globals.truncateString(
                      globals.getMarkupText(freeOffer.LocationAdditionalInfo),
                      50
                    )
                  }}
                </td>
                <td :style="`width:${isSmallScreen ? '15' : '7'}%;`">
                  {{ freeOffer.SurveyInstanceSince }}
                </td>
                <td :style="`width:${isSmallScreen ? '15' : '7'}%;`">
                  {{ freeOffer.SurveyInstanceUntil }}
                </td>
                <td :style="`width:${isSmallScreen ? '15' : '8'}%;`">
                  {{ globals.getCurrencyString(freeOffer.TotalPayment, "EUR") }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <FreeOfferDetailsDialog
      :showDialog="showFreeOfferDetailsDialog"
      :freeOffer="selectedFreeOffer"
      @dialogClosed="closeFreeOfferDetailsDialog"
      @freeOfferAccepted="onFreeOfferAccepted"
    ></FreeOfferDetailsDialog>

    <FreeOfferFilterChecksDialog
      :showDialog="showFreeOfferFilterChecksDialog"
      @dialogClosed="closeFreeOfferFilterChecksDialog"
      @filterChecks="onFilterChecks"
    ></FreeOfferFilterChecksDialog>
  </div>
</template>

<script>
import FreeOfferDetailsDialog from "./FreeOfferDetailsDialog";
import FreeOfferFilterChecksDialog from "./FreeOfferFilterChecksDialog";

export default {
  name: "FreeOffers",
  components: { FreeOfferDetailsDialog, FreeOfferFilterChecksDialog },
  data() {
    return {
      refreshEnabled: false,
      isSmallScreen: false,
      showFreeOfferDetailsDialog: false,
      showFreeOfferFilterChecksDialog: false,
      pageSize: 20,
      selectedPage: 1,
      pageCount: 0,
      checkCount: 0,
      currentSort: { key: "SurveyInstanceId", asc: true },
      freeOffers: [],
      selectedFreeOffer: {},
      selectedFreeOfferGuid: "",
      lang: {
        SFO000: "Refresh",
        SFO001: "Show Details",
        SFO002: "Search...",
        SFO003: "Filter",
        SFO004: "Items per page",
        SFO005: "First page",
        SFO006: "Last page",
        SFO007: "Check data request failed",
        SFO008: "CheckID",
        SFO009: "Since",
        SFO010: "Until",
        SFO011: "Description",
        SFO012: "Project",
        SFO013: "Payment",
        SFO014: "Others",
        SFO015: "Distance",
        SFO016: "Filter",
        SFO017: "Project",
        SFO018: "City",
        SFO019: "Informations",
        SFO020: "Scenario",
        SFO021: "Check Info",
        SFO022: "Postal Code",
        SFO023: "Country",
        SFO024: "Total check count",
        SFO025: "Distance",
      },
      filterStrings: {
        Search: "",
        SurveyInstanceId: "",
        SurveyInstanceSince: "",
        SurveyInstanceUntil: "",
        SurveyInstanceDescription: "",
        LocationCity: "",
        LocationPostalCode: "",
        LocationCountry: "",
        ScenarioName: "",
        SurveyInstanceInfo: "",
        LocationAdditionalInfo: "",
        SurveyTitle: "",
        TotalPayment: "",
      },
      // userProfileLocation: {
      //   PostalCode: "",
      //   Country: ""
      // }
      filterOptions: {},
    };
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
      this.getFreeOffers();
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) {
      this.getFreeOffers();
      this.globals.getLanguageStrings(this);
    }

    let resizeFunc = () => {
      this.isSmallScreen = this.globals.isSmallScreen();
      this.$nextTick(() => {
        this.setElementHeights();
        this.$forceUpdate();
      });
    };
    $(window).off("resize", resizeFunc);
    $(window).on("resize", resizeFunc).resize();
  },
  methods: {
    getFreeOffers() {
      this.selectedFreeOfferGuid = "";

      if (
        !this.filterOptions.CurrentLocation &&
        this.currentSort.key === "Distance"
      )
        this.currentSort = { key: "SurveyInstanceId", asc: true };

      let queryString = `/shopper-api/FreeOffer/SurveyInstances?page_size=${
        this.pageSize
      }&page=${this.selectedPage}&sort_column=${
        this.currentSort.key
      }&sort_order=${this.currentSort.asc ? "asc" : "desc"}`;

      let filterStrings = _.pickBy(this.filterStrings, (value, key) => {
        return value.length > 0;
      });
      let sendData = {};
      if (!_.isEmpty(filterStrings)) sendData.Filter = filterStrings;
      if (!_.isEmpty(this.filterOptions))
        sendData.ParameterFilter = this.filterOptions;
      this.refreshEnabled = false;

      $.ajax({
        method: "POST",
        url: queryString,
        data: _.isEmpty(sendData) ? "" : JSON.stringify(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (!_.isEmpty(data)) {
            this.freeOffers = data[0].SurveyInstances;
            this.pageCount = data[0].Page_Count;
            this.selectedPage = data[0].Page;
            this.pageSize = data[0].Page_Size;
            this.checkCount = data[0].Count;
          }
        },
        error: () => {
          console.error("Error on POST in getFreeOffers()");
          this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.SFO007, colorOrange: false});
        },
        complete: () => {
          this.refreshEnabled = true;
        },
      });
    },
    updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getFreeOffers();
    },
    getRange(min, max, step) {
      var range = [],
        j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },
    getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (
        this.pageCount > 7 &&
        this.selectedPage >= this.pageCount - 3
      ) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },
    showSortArrow(key, asc) {
      return this.currentSort.key === key && this.currentSort.asc === asc;
    },
    orderTableByColumn(orderProp) {
      if (!orderProp && !this.currentSort.key) return;
      if (orderProp) {
        this.currentSort.key === orderProp
          ? (this.currentSort.asc = !this.currentSort.asc)
          : (this.currentSort = { asc: true, key: orderProp });
      }
      this.getFreeOffers();
    },
    setElementHeights() {
      let height = $(window).height();
      /* height -=
        $("#app-navbar").height() +
        $("#free-offer-top-panel").height() +
        $(".main-table > thead").height() +
        47; */

      height -=
        $("#free-offer-top-panel").height() +
        $(".main-table > thead").height() +
        47;

      $(".table-space").css("max-height", height);
      $(".main-table-scrollbar").css("max-height", height);
      let table = $(".main-table-scrollbar");
      table.css("max-height", height);

      // Set top for Filter, that it doesent scroll over table-header
      height = $(".main-table thead tr").height();
      $(".sticky-filter").css("top", height);
      /* if (
        this.globals.isMobileBrowser &&
        this.globals.isScreenOrientationLandscape()
      ) {
        table.css("overflow-y", "visible");
        table.css("height", "0");
      } else {
        table.css("overflow-y", "");
        table.css("height", "");
      } */
    },
    openFreeOfferDetailsDialog() {
      this.selectedFreeOffer = this.freeOffers.find(
        (freeOffer) =>
          freeOffer.SurveyInstanceGuid === this.selectedFreeOfferGuid
      );
      this.showFreeOfferDetailsDialog = true;
    },
    closeFreeOfferDetailsDialog() {
      this.showFreeOfferDetailsDialog = false;
    },
    openFreeOfferFilterChecksDialog() {
      // this.getProfileData();
      this.showFreeOfferFilterChecksDialog = true;
    },
    closeFreeOfferFilterChecksDialog() {
      this.showFreeOfferFilterChecksDialog = false;
    },
    onFreeOfferAccepted() {
      this.getFreeOffers();
    },
    onFilterChecks(filterOptions) {
      if (filterOptions) this.filterOptions = filterOptions;
      else this.filterOptions = {};
      this.selectedPage = 1;
      this.getFreeOffers();
    },
    //   getProfileData() {
    //     let queryString = `shopper-api/Profile`;

    //     $.ajax({
    //       method: "GET",
    //       url: queryString,
    //       success: data => {
    //         this.userProfileLocation = {
    //           PostalCode: data.PostalCode,
    //           Country: data.CountryCode
    //         };
    //       },
    //       error: () => {
    //         console.error("Error on GET in getProfileData()");
    //         this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.SP1038, colorOrange: false});
    //       }
    //     });
    //   }
  },
};
</script>

<style scoped>
.filterbar > input {
  max-height: 35px;
  font-size: 12px;
}

.material-icons.md-18 {
  font-size: 18px;
}

.material-icons.md-36 {
  font-size: 36px;
}

.main-table-scrollbar .material-icons {
  position: relative;
  top: -3px;
}

table.main-table {
  font-size: 12px;
}

@media (max-width: 1000px) {
  .material-icons.md-18 {
    font-size: 24px;
  }
  .material-icons.md-24 {
    font-size: 36px;
  }
  .material-icons.md-36 {
    font-size: 48px;
  }

  @media screen and (max-aspect-ratio: 13/9) {
    .main-table .table-header {
      font-size: 1.2em;
    }
    /* .material-icons.md-18 {
      font-size: 36px;
    }
    .material-icons.md-24 {
      font-size: 48px;
    }
    .material-icons.md-36 {
      font-size: 72px;
    } */
    @media only screen and (hover: none) and (pointer: coarse) {
      table.main-table > thead > tr > th {
        font-size: 32px !important;
      }
      table.main-table {
        font-size: 26px;
      }
      .pagination-fonts {
        font-size: 32px;
      }
      .form-control {
        font-size: 32px !important;
      }
      .material-icons.md-18 {
        font-size: 36px;
      }
      .material-icons.md-20 {
        font-size: 50px;
      }
      .material-icons.md-24 {
        font-size: 48px;
      }
      .material-icons.md-36 {
        font-size: 72px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// FreeOffers.vue?0ac92dd3